import React from 'react';
import { Box, Typography } from '@mui/material';

const Services = () => {
  return (
    <Box
      sx={{
        py: 8,
        px: { xs: 2, sm: 4 },
        maxWidth: 1200,
        mx: 'auto',
      }}
    >
     
      <Typography
        variant="h3"
        align="center"
        sx={{
          mb: { xs: 4, md: 8 },
          color: '#1F212D',
          fontWeight: 600,
        }}
      >
        Our Services
      </Typography>

      {/* First Two Services Side by Side */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' }, // Column on small screens, row on medium+
          gap: 4, // Space between boxes
          mb: 4, // Space below this row
        }}
      >
        {/* Service 1 */}
        <Box
          sx={{
            flex: 1,
            bgcolor: '#FBEEFB',
            borderRadius: 4,
            p: 4,
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            minHeight: 320,
          }}
        >
          <Box sx={{ maxWidth: '60%' }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#1F212D', fontWeight: 600, mb: 2 }}>
              Shift Scheduling & Swap
            </Typography>
            <Typography variant="body1" sx={{ color: '#70758D', lineHeight: 1.6 }}>
              Easily schedule shifts, swap with colleagues, and never worry about coverage again.
              Stay organized and reduce scheduling conflicts with our intuitive platform.
            </Typography>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              height: '140px',
              width: 'auto',
              pr: 2,
            }}
          >
            <img src="/services.svg" 
            alt="services" 
            className='hidden md:block'
            style={{ height: '100%', width: 'auto' ,marginTop:"35%",marginLeft:"6%" }} />
          </Box>
        </Box>

        {/* Service 2 */}
        <Box
          sx={{
            flex: 1,
            bgcolor: '#D7FCEB',
            borderRadius: 4,
            p: 4,
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            minHeight: 320,
          }}
        >
          <Box sx={{ maxWidth: '60%' }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#1F212D', fontWeight: 600, mb: 2 }}>
              Learning & Resources
            </Typography>
            <Typography variant="body1" sx={{ color: '#70758D', lineHeight: 1.6 }}>
              Easily access and share educational content, best practices, and resources with your
              team to stay informed on the latest healthcare advancements.
            </Typography>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              height: '140px',
              width: 'auto',
              pr: 2,
            }}
          >
            <img src="/services2.svg" 
            alt="Learning" 
            className='hidden md:block'
            style=
            {{ height: '100%', width: 'auto',marginTop:"46%",
            marginLeft:"8%" }} />
          </Box>
        </Box>
      </Box>

      {/* Third Service Below */}
      <Box
         className="bg-[#F0F3FF] 
         rounded-4 p-4 md:px-4 md:py-0 relative overflow-hidden min-h-[320px]"
          sx={{
            borderRadius: 4,
          }}
      >
        <Box 
        sx={{ display: 'flex', 
          
          flexDirection: 
        { xs: 'column', md: 'row' }, alignItems: 'center' }}>

          <Box sx={{ flex: 1, maxWidth: '80%', }}>
            <Typography 
            variant="h5" gutterBottom 
            sx={{ color: '#1F212D', fontWeight: 600, mb: 2, }}>
              Instant Communication
            </Typography>
            <Typography variant="body1" sx={{ color: '#70758D', lineHeight: 1.6 }}>
              Connect with your team instantly through chat, voice, and video calls. Seamless
              communication across all devices, keeping everyone in sync.
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'flex-end',
              pr: 2,
            }}
          >
            <img src="/services3.svg" 
           className='hidden md:block '
            alt="Communication" 
             />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Services;
